import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { shallowEqual } from "react-redux";
import { useAppSelector } from "redux-share";
import dynamic from "next/dynamic";
import LiveStatus from "../../player-components/liveStatus/liveStatus";
import Unlock from "../../player-components/lockUnlock/unlock";

const Poll = dynamic(() => import("../../player-components/poll/poll"));
const Lock = dynamic(() => import("../../player-components/lockUnlock/lock"));
const Title = dynamic(() => import("../../player-components/title/title"));
const Snapshot = dynamic(() => import("../../player-components/snapshot/snapshot"));
const FullRate = dynamic(() => import("../../player-components/fullrate/fullrate"));
const AgeClassification = dynamic(() => import("../../player-components/ageClassification/ageClassification"));

const Header = () => {
    useAppSelector(({ controller: { lock, activeElements } }) => ({ lock, activeElements }), shallowEqual);

    return (
        <div className={`pl-flex pl-items-start ${conditions(ConditionName.isLock) ? "pl-justify-end" : "pl-justify-between"} pl-mx-4 pl-mt-5`}>
            <div className="pl-flex-1">
                {conditions(ConditionName.showLiveStatus) && <LiveStatus />}
                {conditions(ConditionName.showTitle) && <Title />}
            </div>
            {conditions(ConditionName.showPoll) && <Poll />}
            {conditions(ConditionName.showFullRate) && <FullRate />}
            <div className="pl-flex pl-items-center pl-gap-4">
                {conditions(ConditionName.showAgeClassification) && <AgeClassification />}
                {conditions(ConditionName.showSnapShot) && <Snapshot />}
                {conditions(ConditionName.isTouchScreenPortrait) ? (
                    <>
                        {conditions(ConditionName.isLock) ? (
                            <Lock
                                className={`animate__animated animate__faster ${
                                    conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"
                                }`}
                            />
                        ) : (
                            <Unlock />
                        )}
                    </>
                ) : (
                    <>
                        {conditions(ConditionName.isLock) && (
                            <Lock
                                className={`animate__animated animate__faster ${
                                    conditions(ConditionName.isActiveElements) ? "animate__fadeInDown" : "animate__fadeOutUp"
                                }`}
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default Header;
